import React from "react";
import { Typography } from "@mui/material";
import FormTextField from "../FormTextField";
import { useBusinessTheme } from "../../hooks/useBusinessTheme";
import CommonButtons from "../CommonButtons";
import { ModalWrapper } from "../ModalWrapper";

export interface FormFieldConfig {
  id: string;
  label?: string;
  required?: boolean;
  type?: "text" | "email" | "phone" | "number" | "section";
  value?: string;
  onChange?: (val: string) => void;
  error?: boolean;
  helperText?: string;
  variant?: "outlined" | "standard";
  inputRef?: React.RefObject<HTMLInputElement>;
  onKeyDown?: (e: React.KeyboardEvent<HTMLInputElement>) => void;
  disabled?: boolean;
}

interface GenericFormProps {
  open: boolean;
  title: string;
  fields: FormFieldConfig[];
  onClose: () => void;
  onSubmit: () => void;
  isFormValid: () => boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  children?: React.ReactNode;
  width?: string;
  showBackButton?: boolean;
  onBack?: () => void;
  isLoading?: boolean;       // ✅ CORRECT PROP
}

const GenericForm: React.FC<GenericFormProps> = ({
  open,
  title,
  fields,
  onClose,
  onSubmit,
  isFormValid,
  confirmLabel = "Submit",
  cancelLabel = "Cancel",
  children,
  width = "max-w-xl",
  showBackButton = false,
  onBack,
  isLoading = false,          // ✅ FIX — use `isLoading`
}) => {
  useBusinessTheme();

  if (!open) return null;

  return (
    <ModalWrapper
      title={title}
      onClose={onClose}
      showCloseButton={true}
      showBackButton={showBackButton}
      onBack={onBack}
      width={width}
      disableClose={isLoading}    // ✅ FIXED
    >
      <div className="grid gap-3 mt-2">
        {fields.map((field) =>
          field.type === "section" ? (
            <Typography key={field.id} variant="subtitle1" fontWeight="bold" mt={1}>
              {field.label}
            </Typography>
          ) : (
            <FormTextField
              key={field.id}
              id={field.id}
              label={field.label || ""}
              required={field.required}
              type={field.type || "text"}
              value={field.value || ""}
              onChange={(e) => field.onChange?.(e.target.value)}
              error={field.error}
              helperText={field.helperText}
              variant={field.variant || "outlined"}
              inputRef={field.inputRef}
              onKeyDown={field.onKeyDown}
              disabled={field.disabled || isLoading}   
            />
          )
        )}
      </div>

      {children}

      <div className="flex justify-end gap-3 mt-6">
        <CommonButtons
          className="w-36 h-10"
          label={cancelLabel}
          variant="outlineDanger"
          onClick={onClose}
          disabled={isLoading}     
        />

        <CommonButtons
          className="w-36 h-10"
          label={confirmLabel}
          onClick={onSubmit}
          disabled={!isFormValid() || isLoading}   
          loading={isLoading}                      
        />
      </div>
    </ModalWrapper>
  );
};

export default GenericForm;
